/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { makeApiRequest } from "../util";

export default function useSummaryApis(token?: string | null) {
  const [configResult, setConfigResult] = useState<any[]>([]);
  const [realTimeResult, setRealTimeResult] = useState<any[]>([]);
  const [orgResult, setOrgResult] = useState<any[]>([]);
  const [orgloading, setOrgLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);

  const getLmrUsersSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/lmr-users/summary`,
        method: "GET",
        token,
      });
      return { "LMR Users": res };
    } catch (e) {
      return { "LMR Users": null };
    }
  };

  const getLmrGroupsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/lmr-groups/summary`,
        method: "GET",
        token,
      });

      return { "LMR Groups": res };
    } catch (e) {
      return { "LMR Groups": null };
    }
  };

  const getLmrMessagesSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/lmr-msgs/summary`,
        method: "GET",
        token,
      });
      return { "LMR Messages": res };
    } catch (e) {
      return { "LMR Messages": null };
    }
  };

  const getMCGrpsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/mc-groups/summary`,
        method: "GET",
        token,
      });
      return { "MC Groups": res };
    } catch (e) {
      return { "MC Groups": null };
    }
  };

  const getMCUsersSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/mc-users/summary`,
        method: "GET",
        token,
      });
      return { "MC Users": res };
    } catch (e) {
      return { "MC Users": null };
    }
  };

  const getDFSIGrpsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/dfsi-groups/summary`,
        method: "GET",
        token,
      });
      return { "DFSI Groups": res };
    } catch (e) {
      return { "DFSI Groups": null };
    }
  };

  const getDFSIChannelsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/dfsi-channels/summary`,
        method: "GET",
        token,
      });
      return { "DFSI Channels": res };
    } catch (e) {
      return { "DFSI Channels": null };
    }
  };

  const getDFSIConnectionsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/dfsi-connections/summary`,
        method: "GET",
        token,
      });
      return { "DFSI Connections": res };
    } catch (e) {
      return { "DFSI Connections": null };
    }
  };

  const getXSSIConnectionsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/xssi-connections/summary`,
        method: "GET",
        token,
      });
      return { "XSSI Connections": res };
    } catch (e) {
      return { "XSSI Connections": null };
    }
  };

  const getOTARConnectionsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/otar-connections/summary`,
        method: "GET",
        token,
      });
      return { "OTAR Connections": res };
    } catch (e) {
      return { "OTAR Connections": null };
    }
  };

  const getLocationsSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/app-config/locations/summary`,
        method: "GET",
        token,
      });
      return { Locations: res.total };
    } catch (e) {
      return { Locations: null };
    }
  };

  const getPublishInfoSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/realtime/mc/publish-info/summary`,
        method: "GET",
        token,
      });
      return { "Publish Info": res };
    } catch (e) {
      return { "Publish Info": null };
    }
  };

  const getP25UnitSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/realtime/p25/ss-reg-unit/summary`,
        method: "GET",
        token,
      });
      return { "P25 Supp. Service Reg. (Unit)": res };
    } catch (e) {
      return { "P25 Supp. Service Reg. (Unit)": null };
    }
  };

  const getP25GroupSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/realtime/p25/ss-reg-group/summary`,
        method: "GET",
        token,
      });
      return { "P25 Supp. Service Reg. (Group)": res };
    } catch (e) {
      return { "P25 Supp. Service Reg. (Group)": null };
    }
  };

  const getFixedNetworkSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/realtime/p25/ss-reg-fne/summary`,
        method: "GET",
        token,
      });
      return { "P25 Supp. Service Reg. (FNE)": res };
    } catch (e) {
      return { "P25 Supp. Service Reg. (FNE)": null };
    }
  };

  const getAffiliationSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/realtime/p25/group-aff/summary`,
        method: "GET",
        token,
      });
      return { "P25 Group Affiliations": res };
    } catch (e) {
      return { "P25 Group Affiliations": null };
    }
  };

  const getOrgSummary = async ({
    token,
  }: {
    token?: string | null;
  }): Promise<any> => {
    try {
      const res = await makeApiRequest<any>({
        path: `/api/v1/organisations/summary`,
        method: "GET",
        token,
      });
      return [
        { Organisations: res.organisations_total },
        { Mappings: res.mappings_total },
      ];
    } catch (e) {
      return [{ Organisations: null }, { Mappings: null }];
    }
  };

  useEffect(() => {
    async function fetchConfigSummaryApis() {
      try {
        setConfigLoading(true);
        const r1 = await Promise.allSettled([
          getLmrUsersSummary({ token }),
          getLmrGroupsSummary({ token }),
          getLmrMessagesSummary({ token }),
          getMCGrpsSummary({ token }),
          getMCUsersSummary({ token }),
          getDFSIGrpsSummary({ token }),
          getDFSIChannelsSummary({ token }),
          getDFSIConnectionsSummary({ token }),
          getXSSIConnectionsSummary({ token }),
          getOTARConnectionsSummary({ token }),
        ]);
        setConfigResult(r1);
      } catch (error) {
        throw new Error("some error occured");
      } finally {
        setConfigLoading(false);
      }
    }
    async function fetchOrgSummaryApis() {
      try {
        setOrgLoading(true);
        const r2 = await Promise.allSettled([
          getOrgSummary({ token }),
          getLocationsSummary({ token }),
        ]);
        setOrgResult(r2);
      } catch (error) {
        throw new Error("some error occured");
      } finally {
        setOrgLoading(false);
      }
    }

    async function fetchRealTimeSummaryAPis() {
      try {
        setConfigLoading(true);
        const r3 = await Promise.allSettled([
          getPublishInfoSummary({ token }),
          getP25UnitSummary({ token }),
          getP25GroupSummary({ token }),
          getFixedNetworkSummary({ token }),
          getAffiliationSummary({ token }),
        ]);
        setRealTimeResult(r3);
      } catch (error) {
        throw new Error("some error occured");
      } finally {
        setConfigLoading(false);
      }
    }

    fetchOrgSummaryApis();
    fetchConfigSummaryApis();
    fetchRealTimeSummaryAPis();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { configResult, realTimeResult, orgResult, orgloading, configLoading };
}
